import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-disable",
  "use": "rt-base-disable-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-disable\">\n<path d=\"M512.4,64.1c-247.4,0-448,200.6-448,448s200.6,448,448,448s448-200.6,448-448S759.8,64.1,512.4,64.1z M512.4,128.1\n\tc102.6,0,199,39.9,271.5,112.5c72.5,72.5,112.5,169,112.5,271.5c0,92.4-32.4,179.8-91.8,249.2L263.2,220\n\tC332.7,160.5,420,128.1,512.4,128.1z M240.9,783.7c-72.5-72.5-112.5-169-112.5-271.5c0-91.3,31.6-177.7,89.7-246.8l541,541\n\tc-69,58.1-155.5,89.7-246.8,89.7C409.8,896.1,313.4,856.2,240.9,783.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/disable.svg
// module id = 1267
// module chunks = 124